import { useRegions } from '../lib/api-client'
import { LoadingCard } from '../components/LoadingSpinner'
import { RegionDistributionChart } from '../components/charts/RegionDistributionChart'
import { exportToCSV, exportToJSON } from '../lib/export'
import { useDateRange } from '../components/Layout'

export function Geography() {
  const { startDate, endDate } = useDateRange()
  const regions = useRegions(startDate, endDate)

  const handleExportCSV = () => {
    if (regions.data?.data) {
      exportToCSV(regions.data.data, 'geographic-distribution')
    }
  }

  const handleExportJSON = () => {
    if (regions.data?.data) {
      exportToJSON(regions.data.data, 'geographic-distribution')
    }
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-foreground">
          Geographic Distribution
        </h2>
        <div className="flex gap-2">
          <button
            onClick={handleExportCSV}
            disabled={!regions.data}
            className="px-3 py-1 text-sm bg-secondary rounded-lg hover:bg-secondary/80 disabled:opacity-50"
          >
            Export CSV
          </button>
          <button
            onClick={handleExportJSON}
            disabled={!regions.data}
            className="px-3 py-1 text-sm bg-secondary rounded-lg hover:bg-secondary/80 disabled:opacity-50"
          >
            Export JSON
          </button>
        </div>
      </div>

      {/* Chart */}
      <div className="bg-card rounded-lg border border-border p-6">
        <h3 className="text-lg font-semibold mb-4">Visitors by Region</h3>
        {regions.isLoading ? (
          <LoadingCard />
        ) : regions.data ? (
          <div className="h-[400px]">
            <RegionDistributionChart data={regions.data.data} />
          </div>
        ) : (
          <p className="text-muted-foreground">No data available</p>
        )}
      </div>

      {/* Table */}
      <div className="bg-card rounded-lg border border-border overflow-hidden">
        <table className="w-full">
          <thead className="bg-secondary/50">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-medium text-muted-foreground">
                Region
              </th>
              <th className="px-4 py-3 text-right text-sm font-medium text-muted-foreground">
                Events
              </th>
              <th className="px-4 py-3 text-right text-sm font-medium text-muted-foreground">
                Unique Visitors
              </th>
              <th className="px-4 py-3 text-right text-sm font-medium text-muted-foreground">
                %
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {regions.isLoading ? (
              <tr>
                <td colSpan={4} className="px-4 py-8 text-center">
                  <div className="flex justify-center">
                    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary" />
                  </div>
                </td>
              </tr>
            ) : regions.data?.data.length ? (
              regions.data.data.map((row, i) => (
                <tr key={i} className="hover:bg-secondary/30">
                  <td className="px-4 py-3 text-sm font-medium">{row.region}</td>
                  <td className="px-4 py-3 text-sm text-right">
                    {row.events.toLocaleString()}
                  </td>
                  <td className="px-4 py-3 text-sm text-right">
                    {row.unique_visitors.toLocaleString()}
                  </td>
                  <td className="px-4 py-3 text-sm text-right text-muted-foreground">
                    {row.percentage.toFixed(1)}%
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={4}
                  className="px-4 py-8 text-center text-muted-foreground"
                >
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
